import { gql } from '@apollo/client';

export const GET_PAGES = gql`
  query GetPages(
    $page: Int
    $limit: Int
    $showcase_only: Boolean
    $search_text: String
  ) {
    pagesPaginated(
      page: $page
      limit: $limit
      showcase_only: $showcase_only
      search_text: $search_text
    ) {
      total
      page
      limit
      totalPages
      data {
        id
        name
        slug
        vtex_query
        show_tab_bar
        header_type
      }
    }
  }
`;

export const GET_ELEMENT_DISPLAYS = gql`
  query GetElementDisplays($element_id: String) {
    elementDisplays(element_id: $element_id) {
      id
      name
      slug
    }
  }
`;

export const GET_PAGE_DATA = gql`
  query GetPageData($slug: String!, $active_only: Boolean) {
    elements(args: { active_only: $active_only }) {
      id
      name
      slug
      active
      displays(args: { active_only: $active_only }) {
        element_id
        id
        name
        description
        active
        preview
        slug
      }
    }
    page(args: { slug: $slug }) {
      id
      name
      vtex_query
      show_tab_bar
      header_type
      slug
      groups(workbench: true) {
        id
        element_display_id
        name
        padding
        padding_top
        padding_bottom
        padding_left
        padding_right
        border_top
        border_bottom
        border_left
        border_right
        vertical_padding
        horizontal_padding
        vtex_query
        description
        reference_id
        clicks
        cols
        round_shape
        rounded_size
        redirect_value
        rows
        width
        height
        gap
        type
        guidance_type
        size
        is_full_width_banner
        category_id
        countdown
        schedule_start
        schedule_end
        display {
          slug
        }
        products {
          productId
          productName
          items {
            name
            nameComplete
            images {
              imageUrl
            }
            sellers {
              sellerName
              commertialOffer {
                ListPrice
                Price
                Installments {
                  Value
                  NumberOfInstallments
                  TotalValuePlusInterestRate
                  PaymentSystemName
                  PaymentSystemGroupName
                }
                AvailableQuantity
                IsAvailable
              }
            }
          }
        }
        product {
          productId
          productName
          items {
            name
            nameComplete
            itemId
            images {
              imageUrl
            }
            sellers {
              sellerName
              commertialOffer {
                ListPrice
                Price
                Installments {
                  Value
                  NumberOfInstallments
                  TotalValuePlusInterestRate
                  PaymentSystemName
                  PaymentSystemGroupName
                }
                AvailableQuantity
                IsAvailable
              }
            }
          }
        }
        items(workbench: true) {
          id
          name
          description
          clicks
          type
          countdown
          facets
          modal
          weight
          has_modal
          text_color
          filter_data
          highlighted
          image_align
          background_color
          width
          height
          image_description
          reference_value
          redirect_type
          redirect_value
          redirect_data
          reference_id
          schedule_start
          schedule_end
          file {
            id
            name
            url
          }
        }
      }
    }
  }
`;

export const GET_GROUP_WITH_ELEMENTS = gql`
  query GetGroupWithElements($group_id: String!) {
    pageGroup(id: $group_id) {
      id
      name
      items {
        id
        name
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query GetCategories {
    categories(treeLevel: 5, workbench: true) {
      id
      file_id
      name
      reference_id
      active
      url
      Title
      MetaTagDescription
      file {
        url
      }
      children {
        id
        file_id
        name
        reference_id
        active
        url
        Title
        MetaTagDescription
        file {
          url
        }
        children {
          id
          file_id
          name
          reference_id
          active
          url
          Title
          MetaTagDescription
          file {
            url
          }
          children {
            id
            file_id
            name
            reference_id
            active
            url
            Title
            MetaTagDescription
            file {
              url
            }
            children {
              id
              file_id
              name
              reference_id
              active
              url
              Title
              MetaTagDescription
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`;
